var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCroatia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 256.001C512 224.687 506.367 194.69 496.077 166.958L256 155.827L15.923 166.957C5.633 194.69 0 224.687 0 256.001C0 287.315 5.633 317.312 15.923 345.044L256 356.175L496.077 345.045C506.367 317.312 512 287.315 512 256.001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 512.001C366.071 512.001 459.906 442.529 496.077 345.044H15.9229C52.0939 442.529 145.929 512.001 256 512.001Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9229 166.958H496.078C459.906 69.473 366.071 0.000976562 256 0.000976562C145.929 0.000976562 52.0939 69.473 15.9229 166.958V166.958Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.783 178.089H278.261L285.682 122.436L315.362 100.175L345.043 122.436V166.958L322.783 178.089Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.217 178.089H233.739L226.318 122.436L196.637 100.175L166.957 122.436V166.958L189.217 178.089Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.682 178.089H226.318V122.436L256 100.175L285.682 122.436V178.089Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.957 166.959V289.393C166.957 318.546 181.039 344.472 202.759 360.725L218.342 356.826L238.006 376.608C243.821 377.806 249.838 378.437 256.001 378.437C262.131 378.437 268.118 377.814 273.902 376.628L296.349 357.938L309.241 360.689C330.952 344.437 345.044 318.538 345.044 289.393V166.959H166.957Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.957 166.958H202.574V202.575H166.957V166.958Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.191 166.958H273.808V202.575H238.191V166.958Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.426 166.958H345.043V202.575H309.426V166.958Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.574 202.575H238.191V238.192H202.574V202.575Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.809 202.575H309.426V238.192H273.809V202.575Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.957 238.181H202.574V273.798H166.957V238.181Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.574 273.799H238.191V309.416H202.574V273.799Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.191 238.181H273.808V273.798H238.191V238.181Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.426 238.181H345.043V273.798H309.426V238.181Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.809 273.799H309.426V309.416H273.809V273.799Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.191 309.416H273.808V345.033H238.191V309.416Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.574 309.419H169.255C172.311 322.659 178.319 334.774 186.557 345.036H202.574V309.419Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.426 345.037H325.442C333.682 334.775 339.688 322.659 342.744 309.42H309.426V345.037Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.574 345.037V360.578C212.933 368.373 225.039 373.962 238.191 376.644V345.037H202.574Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.809 345.037V376.644C286.962 373.964 299.067 368.373 309.426 360.578V345.037H273.809Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroatia);
export default __webpack_public_path__ + "static/media/croatia.014a02f84f7feb7d48c5ee638ce46dd8.svg";
export { ForwardRef as ReactComponent };